<template>
  <div>
    <div class="navigation--sub">
      <div v-bind:class="container" class="container--no-margin">
        <div class="row">
          <div class="col-12">
            <div class="tabs">
              <div
                class="tabs--tab"
                v-for="tab in tabs"
                :class="{ 'tabs--tab-active': tab.isActive }"
                :key="tab"
              >
                <a @click="selectTab(tab)">{{ tab.name }}</a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div v-bind:class="isFullWidth">
      <div class="row">
        <div class="col-12">
          <div class="tabs-details">
            <slot></slot>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "Tabs",
  components: {},
  data() {
    return { tabs: [] };
  },
  props: {
    fullWidth: Boolean,
  },
  created() {
    this.tabs = this.$children;
  },
  methods: {
    selectTab(selectedTab) {
      this.tabs.forEach((tab) => {
        tab.isActive = tab.name == selectedTab.name;
      });
    },
  },
  computed: {
    isFullWidth() {
      return this.fullWidth ? "container-fluid" : "container";
    },
  },
};
</script>
